import { useQuery } from 'react-query'
import { EditModalForm } from './EditModalForm'
import { QUERIES } from '../../../../../_metronic/helpers'
import { useListView } from '../core/ListViewProvider'
import { getRoleGroupById } from '../core/_requests'
import { useAuth } from '../../../../modules/auth/core/Auth'
import { Loading } from '../../../../../_metronic/layout/components/loading/Loading'
import Swal from 'sweetalert2'
import { useQueryResponse } from '../core/QueryResponseProvider'

const UserEditModalFormWrapper = () => {
  const { auth } = useAuth()
  const { itemIdForUpdate, setItemIdForUpdate } = useListView()
  const enabledQuery: boolean = itemIdForUpdate !== "0"
  const { refetch } = useQueryResponse()
  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate('')
  }
  const {
    isLoading,
    data: roleGroup,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-user-${itemIdForUpdate}`,
    () => {
      return getRoleGroupById(auth?.configs, itemIdForUpdate || "")
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err: any) => {
        Swal.fire({
          icon: 'error',
          title: 'Không tìm thấy dữ liệu',
          text: ' ',
          confirmButtonText: 'Đóng lại',
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            cancel(true)
          }
        })
      },
    }
  )

  if (itemIdForUpdate === "0") {
    return <EditModalForm isUserLoading={isLoading} roleGroup={{ Id: "0" }} />
  }

  if (!isLoading && !error && roleGroup) {
    return <EditModalForm isUserLoading={isLoading} roleGroup={roleGroup} />
  }

  return <Loading />
}

export { UserEditModalFormWrapper }
